import { Api } from 'utils';

class VehicleService {
	
	static get = async (params?: any) => Api.createResponse('client/vehicles',params);
	static save = async (params?: any) => Api.createResponse('client/vehicles/save',params);
	static changeStatus = async (params?: any) => Api.createResponse('client/vehicles/change-status',params);
	static view = async (params?: any) => Api.createResponse('client/vehicles/view',params);
	static delete = async (params?: any) => Api.createResponse('client/vehicles/delete',params);
	static readFile = async (params?: any) => Api.createResponse('client/vehicles/read-file',params);

}

export default VehicleService;